import { required } from "../../shared/src/codecs/types/required";
import { uuid } from "../../shared/src/codecs/types/uuid";

export const CaseId = required({
    case_id: uuid(),
})
export type TCaseIdCodec = typeof CaseId;
